export enum ViewState {
  MENU = 'MENU',
  CITY = 'CITY',
  PRACTICE_ROOM = 'PRACTICE_ROOM',
  STAGE = 'STAGE',
  PLANE_STAGE = 'PLANE_STAGE',
  VARIETY_SHOW = 'VARIETY_SHOW',
  CAFE = 'CAFE',
  BATHHOUSE = 'BATHHOUSE',
  HEALER_CLINIC = 'HEALER_CLINIC',
  SPICY_CHALLENGE = 'SPICY_CHALLENGE',
  RECORD_LABEL = 'RECORD_LABEL',
  MERCH_SHOP = 'MERCH_SHOP',
  TOUR_MAP = 'TOUR_MAP',
  CUTSCENE = 'CUTSCENE',
  SKY_DROP = 'SKY_DROP',
  SETLIST = 'SETLIST',
  STREET_FOOD = 'STREET_FOOD'
}

export enum IdolRank {
  TRAINEE = 0,
  ROOKIE = 1,
  IDOL = 2,
  SUPERSTAR = 3,
  LEGEND = 4
}

export type MemberRole = 'LEADER' | 'DANCER' | 'RAPPER';
export type CostumeId = 'DEFAULT' | 'PAJAMAS' | 'LEATHER' | 'HANBOK';

export interface HuntrixMember {
  id: string;
  name: string;
  role: MemberRole;
  maxSpirit: number;
  spirit: number; // HP
  vocal: number;
  dance: number;
  style: number;
  price: number;
  vocalDebuff?: number;
  costume: CostumeId; // NEW
}

export interface GroupConfig {
  name: string;
  members: HuntrixMember[];
}

export interface ProducerSkills {
  songwriting: number;
  choreography: number;
  marketing: number;
}

export interface PlayerProfile {
  name: string; // Producer Name
  cash: number;
  fans: number;
  rank: IdolRank;
  group: GroupConfig;
  skills: ProducerSkills;
  merchStock: number;
  currentCity: string;
  activeContracts: Mission[];
  mysticWards: number;
  tonicCount: number;
  hasAchievedGoldenHonmoon?: boolean;
  conqueredCities: string[];
  unlockedCostumes: CostumeId[]; // NEW
}

export interface Mission {
  id: string;
  title: string;
  description: string;
  origin: string;
  destination: string;
  reward: number; // Cash
  fanReward: number; // Fans
  type: 'TOUR_DATE' | 'COLLAB' | 'ENDORSEMENT';
}

export interface DialogueLine {
  speaker: string;
  text: string;
  emotion?: 'NEUTRAL' | 'HAPPY' | 'DANGER' | 'PROUD';
  portrait?: string;
}

export interface CutsceneScript {
  id: string;
  lines: DialogueLine[];
  nextView: ViewState;
}
export interface FoodItem {
  id: string;
  name: string;
  emoji: string;
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  description: string;
  ingredients: string[];
  allergens?: string[];
  cookingMethod?: string;
  image?: string;
}

export interface StreetFoodQuest {
  id: string;
  name: string;
  description: string;
  location: string;
  reward: number;
  fanReward: number;
  difficulty: 'EASY' | 'MEDIUM' | 'HARD';
  image?: string;
  requirements: string[];
  completed: boolean;
  foodItems: FoodItem[];
}
